// Pure window math for the WL MP3 preload window (see
// docs/superpowers/specs/2026-06-16-wl-mp3-preload-window-design.md).
//
// Given the ordered song list and the anchor (the smallest visible card index),
// return the set of song ids in the rolling window: WINDOW_ABOVE cards above the
// anchor and the rest below, WINDOW_SIZE total, clamped to the list bounds.

/** Max preloaded MP3 cards. */
export const WINDOW_SIZE = 15;
/** Cards kept warm above the anchor (the rest of the window is below it). */
export const WINDOW_ABOVE = 3;

export function computePreloadWindowIds(
  songs: ReadonlyArray<{ id: string }>,
  anchorIndex: number | null,
): Set<string> {
  const ids = new Set<string>();
  if (anchorIndex === null || songs.length === 0) {
    return ids;
  }
  const start = Math.max(0, anchorIndex - WINDOW_ABOVE);
  const end = Math.min(songs.length, start + WINDOW_SIZE);
  for (let i = start; i < end; i++) {
    ids.add(songs[i].id);
  }
  return ids;
}
